import { createApp } from './App'

export const { initAppForPage, createControllers } = createApp()
